var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCronos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.681 17.27l-5.63 3.268-5.627-3.268V10.73l5.628-3.27 5.63 3.27-2.346 1.361-3.284-1.907-3.283 1.907v3.815l3.283 1.907 3.284-1.907 2.345 1.363z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.054 0L0 7.003v13.998L12.054 28l12.051-6.999V7.003L12.054 0zm8.48 18.926l-8.48 4.924-8.483-4.924v-9.85l8.483-4.926 8.48 4.926v9.85z",
    fill: "#fff"
  })));
}

export default SvgCronos;